export interface MAdjTemplate {
  id: string;
  name: string;
  differenceType: 'Permanent' | 'Temporary';
  calcType: 'Manual' | 'IncomeStatement' | 'BS_Liability' | 'BS_Liability_Payout' | 'BS_Asset' | 'BS_Asset_Payout' | 'Meals50';
}

export const M_ADJ_REGISTRY: MAdjTemplate[] = [
  { id: 'M-DEPR',    name: 'Depreciation',                    differenceType: 'Temporary', calcType: 'IncomeStatement' },
  { id: 'M-PENALTY', name: 'Penalties and Fines',             differenceType: 'Permanent', calcType: 'IncomeStatement' },
  { id: 'M-MEALS',   name: 'Meals & Entertainment (50%)',     differenceType: 'Permanent', calcType: 'Meals50' },
];
